export const API = {
  AUTH: {
    LOGIN: "v2/auth",
    FORGOT: "reset-password",
    GETOTP: "v2/authentication/getOtp",
    VERIFY_OTP: "v2/authentication/verifyOtp",
    VERIFY_OTP_FORGET_PASSWORD: "reset-password/verifyCode",
    RESEND_OTP: "v2/authentication/resendOtp",
    RESEND_OTP_FORGET_PASSWORD: "reset-password/resendCode",
    // REGISTER: "v2/web/auth/register",
    REGISTER: "v2/authentication/register",
    // FORGOT_PASSWORD: "v2/web/auth/reset-password",
    FORGOT_PASSWORD: "reset-password/sendCode",
    SET_NEW_PASSWORD: "v2/authentication/set-password",
  },
  // AUTH: {
  //   LOGIN: "v3/authentication/login",
  //   LOGOUT: "v2/auth",
  //   FORGOT: "v3/reset-password",
  //   GETOTP: "v3/authentication/getOtp",
  //   VERIFY_OTP: "v3/authentication/verifyOtp",
  //   VERIFY_OTP_FORGET_PASSWORD: "v3/reset-password/verifyCode",
  //   RESEND_OTP: "v3/authentication/resend-otp",
  //   RESEND_OTP_FORGET_PASSWORD: "v3/authentication/resend-otp",
  //   REGISTER: "v3/authentication/register",
  //   FORGOT_PASSWORD: "v3/reset-password/sendCode",
  //   SET_NEW_PASSWORD: "v3/authentication/set-password",
  // },
  OTHER: {
    LANGUAGE_SETTINGS: "v2/label/web",
    ALL_LANGUAGES: "v2/languages",
    GET_INTERESTS: "v2/interest/withCategory",
    GET_PROFILE_DETAILS: "v2/self",
    DELETE_PROFILE_IMAGE: "v2/self/avatar",
    GET_ARTROOM_INFO: "v2/users",
    GET_ARTROOM_DETAILS: "arts",
    CHECK_SHIPPING_DETAILS: "v2/shipping/services",
    GET_REPOST_DETAILS: "v2/repost/users",
    GET_EVENT: "v2/users",
    DELETE_FEED: "publications",
    FEED_RESPONSES: "publications-comments",
    ADD_COMMENTS: "v2/web/publication",
    GET_ARTS_WEEKS: "v2/artOfTheWeek/arts/topArts",
    GET_ARTISTS_WEEKS: "v2/artistOfTheWeek/artist/topArtist",
    GET_HOME_POSTS: "v2/publications/repost/ads",
    LIKE_ARTROOM: "arts/like",
    PIECES: "search/lamdafunctionArt",
    PEOPLE: "search/lamdafunctionArt",
    START: "startup/v2",
    // TAGS: "search/lamdafunctionArt",
    // PIECES: "search/arts",
    // PEOPLE: "search/arts",
    // START: "startup/v2",
    TAGS: "search/tags",
    OPPORTUNITIES: "opportunities",
    APPLY_OPPORTUNITY: "opportunities/submit-application",
    MASTER_CLASS: "v2/masterclasses",
    USERS_PROFILE: "v2/users/publishers",
    FOLLOW_USERS: "v2/follows/follow",
    CREATE_POST: "publications/image",
    CREATE_REEL: "/reel",
    UNFOLLOW_USERS: "v2/follows/unfollow",
    CREATE_ARTROOM_POST: "publications/art-images",
    CREATE_ARTROOM_VIDEO: "publications/art-video",
    CREATE_POST_VIDEO: "publications/video",
    CHANGE_PASSWORD: "v2/self/password",
    CREATE_POST_TEXT: "publications/text",
    DELETE_REPOST: "v2/repost/publication",
    ADD_REPOST: "v2/repost",
    PURCHASE_LIST: "history/purchases",
    SALES_LIST: "history/sellings",
    MASTER_CLASS_LIST: "v2/user/masterClassSubscription",
    MASTER_CLASS_SUBSCRIPTION: "v2/user/masterClassSubscription/detail",
    MASTER_CLASS_SUBSCRIPTION_BUY:
      "v2/user/masterClassSubscription/buy-masterclass",
    TRANSACTION_LIST: "v2/transaction/user",
    NOTIFICATION_PREF: "v2/self/preferences",
    REPORT_BUG: "bug-reports",
    REPORT_USER: "flags/publications",
    REPORT_USER_ARTIST: "flags/users",
    REPORT_COMMENT: "flags/publications-comments",
    NOTIFICATION_LIST: "notifications/mynotifications",
    NOTIFICATIONS: "notifications",
    MUTE_NOTIFICATIONS: "notifications/mutenotificationsfor",
    NOTIFICATION_COUNT: "notifications/count",
    CONNECT_STRIPE: "payments/create-account",
    STRIPE_VERIFY: "payments/stripe/verify-account",
    CONNECT_STRIPE_ACCOUNT: "payments/stripe/create-account",
    CONNECT_STRIPE_LINK: "payments/account-link",
    GET_STRIPE_LINK: "payments/create-login-link",
    GET_CARDS: "payments/get-cards",
    ADD_CARD: "payments/add-card",
    SAVE_CARD: "payments/save-card",
    GET_LOCATION: "cities",
    ADD_EVENT: "publications/events",
    RESET_NOTIFICATION_COUNT: "notifications/reset",
    GET_QR_CODE: "v2/self/getQrCodeData",
    NOTIFICATION_SEEN: "notifications/seen",
    UserPinPost: "v2/publications/pin",
    UserUnPinPost: "v2/publications/unpin",
    GET_PROFILE_COLORS: "v2/self/profile-colors",
    GET_COUNTRYS: "v2/countries",
    GETUSER_HAS_PASSWORD: "v2/authentication/self",
    AWIN_CLICK: "v2/awin/user/track",
    VIEW_POST: "v2/publications",
    UPDATE_EMAIL: "v2/self/sendCode",
    VERIFY_EMAIL_OTP: "v2/self/verifyCode",
    RESEND_EMAIL_OTP: "v2/self/resendCode", 
    REEL_FEED: "reel",
    likeReel: "publications",
    REPORT_REEL: "flags/publications",
    REEL_CONFIG: "v2/label/all",
  },
};
